var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTechFigure4(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 276,
    height: 248,
    viewBox: "0 0 276 248",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_880_1115)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M161.906 116.685L157.365 116.353L161.986 91.9053L170.631 92.5321L161.906 116.685ZM157.971 115.887L161.559 116.149L169.925 92.991L162.402 92.4452L157.971 115.887Z",
    fill: "#1F1F1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.231 116.691L153.636 92.5245L162.505 91.8984L157.882 116.36L153.231 116.691ZM154.136 92.9988L153.749 116.144L157.454 115.881L161.883 92.4522L154.136 92.9988Z",
    fill: "#1F1F1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.719 117.592L161.395 116.601L170.115 92.4639L178.335 94.3326L165.719 117.592ZM162.069 116.233L165.456 117.009L177.569 94.6798L170.441 93.0594L162.069 116.233Z",
    fill: "#1F1F1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.093 117.604L145.264 94.3107L154.146 92.4473L153.741 116.624L149.093 117.604ZM145.845 94.7086L149.509 116.997L153.239 116.21L153.627 93.076L145.845 94.7086Z",
    fill: "#1F1F1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.731 25.3678L156.983 24.1758L161.61 0.233398L182.401 1.71L173.731 25.3678ZM157.591 23.7094L173.385 24.8334L181.69 2.16941L162.023 0.772762L157.591 23.7094Z",
    fill: "#1F1F1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.304 25.3771L140.783 1.70189L162.129 0.226562L157.499 24.1826L140.304 25.3771ZM141.283 2.17722L140.824 24.8313L157.074 23.7024L161.504 0.779353L141.283 2.17722Z",
    fill: "#1F1F1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.225 119.058L165.229 117.429L177.837 94.1851L185.425 97.2597L169.225 119.058ZM165.946 117.172L169.052 118.438L184.624 97.4842L178.067 94.8273L165.946 117.172Z",
    fill: "#1F1F1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.051 119.072L137.07 97.2173L145.756 94.1694L149.587 117.469L145.051 119.072ZM137.724 97.5267L145.356 118.424L149.015 117.132L145.353 94.8499L137.724 97.5267Z",
    fill: "#1F1F1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.14 28.8502L173.22 25.2853L181.883 1.64307L201.649 6.03788L189.14 28.8502ZM173.897 24.9157L188.877 28.27L200.877 6.38754L182.208 2.23609L173.897 24.9157Z",
    fill: "#1F1F1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.569 28.8628L119.873 6.01658L141.294 1.62695L140.814 25.3126L123.569 28.8628ZM120.453 6.41689L123.986 28.2579L140.314 24.8964L140.772 2.25278L120.453 6.41689Z",
    fill: "#1F1F1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.336 121.048L168.77 118.818L184.96 97.0327L191.735 101.241L172.336 121.048ZM169.507 118.679L172.259 120.4L190.928 101.338L185.089 97.7117L169.507 118.679Z",
    fill: "#1F1F1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.199 121.061L129.251 101.19L137.538 97.0166L145.52 118.873L141.199 121.061ZM129.969 101.397L141.391 120.394L144.887 118.623L137.256 97.7278L129.969 101.397Z",
    fill: "#1F1F1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.978 123.519L171.932 120.734L172.116 120.545L191.321 100.937L197.11 106.181L174.978 123.519ZM172.663 120.713L175.004 122.853L196.321 106.153L191.342 101.642L172.663 120.713Z",
    fill: "#1F1F1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.632 123.521L121.995 106.123L129.69 100.933L141.637 120.802L137.632 123.521ZM122.764 106.218L137.713 122.851L140.953 120.652L129.53 101.654L122.764 106.218Z",
    fill: "#1F1F1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.362 34.5485L188.647 28.6899L201.148 5.89355L219.429 13.1276L203.362 34.5485ZM189.37 28.4302L203.188 33.932L218.623 13.3556L201.378 6.53179L189.37 28.4302Z",
    fill: "#1F1F1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.158 34.5661L99.3511 13.0886L120.366 5.87793L124.062 28.7306L107.158 34.5661ZM100.006 13.4016L107.465 33.9219L123.492 28.3894L119.96 6.55487L100.006 13.4016Z",
    fill: "#1F1F1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.083 126.405L174.638 123.139L196.762 105.808L201.422 111.969L177.083 126.405ZM175.344 123.233L177.216 125.735L200.673 111.822L196.669 106.527L175.344 123.233Z",
    fill: "#1F1F1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.435 126.403L115.482 111.913L122.4 105.813L138.033 123.206L134.435 126.403ZM116.282 111.885L134.411 125.745L137.312 123.166L122.358 106.528L116.282 111.885Z",
    fill: "#1F1F1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.595 129.64L176.819 125.971L201.154 111.536L204.563 118.466L178.595 129.64ZM177.48 126.17L178.841 128.98L203.871 118.21L200.94 112.254L177.48 126.17Z",
    fill: "#1F1F1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.689 129.631L109.873 118.419L115.847 111.552L134.792 126.036L131.689 129.631ZM110.682 118.263L131.566 128.996L134.054 126.112L115.917 112.246L110.682 118.263Z",
    fill: "#1F1F1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.068 42.3461L202.904 34.3114L218.961 12.9048L235.338 22.8254L216.068 42.3461ZM203.646 34.1689L215.989 41.7019L234.523 22.9267L219.091 13.5783L203.646 34.1689Z",
    fill: "#1F1F1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.4527 42.3595L79.6885 22.7734L99.8209 12.8921L107.629 34.3712L91.4527 42.3595ZM80.4096 22.986L91.6474 41.696L106.995 34.1169L99.5363 13.5984L80.4096 22.986Z",
    fill: "#1F1F1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.328 140.427L152.839 140.293L157.46 115.85L162.085 116.188L153.328 140.427ZM157.876 116.39L153.929 137.268L161.379 116.646L157.876 116.39Z",
    fill: "#1F1F1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.339 140.388L152.835 140.336L153.24 116.18L157.979 115.843L153.339 140.388ZM153.74 116.654L153.393 137.362L157.357 116.398L153.74 116.654Z",
    fill: "#1F1F1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.312 140.462L152.85 140.254L161.569 116.119L165.971 117.128L153.312 140.462ZM161.895 116.716L154.475 137.252L165.204 117.474L161.895 116.716Z",
    fill: "#1F1F1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.838 140.382L149.011 117.102L153.749 116.103L153.343 140.345L152.838 140.382ZM149.591 117.499L152.882 137.514L153.23 116.732L149.591 117.499Z",
    fill: "#1F1F1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.293 140.492L152.865 140.219L165.473 116.979L169.538 118.636L153.293 140.492ZM165.703 117.622L155.016 137.322L168.739 118.859L165.703 117.622Z",
    fill: "#1F1F1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.85 140.428L144.876 118.594L149.503 116.959L153.34 140.299L152.85 140.428ZM145.53 118.902L152.399 137.709L149.099 117.641L145.53 118.902Z",
    fill: "#1F1F1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.485 133.139L178.415 129.163L204.384 117.989L206.457 125.513L179.485 133.139ZM179.021 129.456L179.842 132.509L205.832 125.161L204.049 118.687L179.021 129.456Z",
    fill: "#1F1F1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.464 133.129L105.309 125.482L110.19 118.01L131.994 129.215L129.464 133.129ZM106.102 125.2L129.247 132.527L131.262 129.411L110.365 118.672L106.102 125.2Z",
    fill: "#1F1F1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.271 140.518L152.885 140.189L169.074 118.408L172.7 120.676L153.271 140.518ZM169.203 119.088L155.526 137.488L171.895 120.771L169.203 119.088Z",
    fill: "#1F1F1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.871 140.471L140.936 120.624L145.344 118.392L153.328 140.253L152.871 140.471ZM141.654 120.83L151.94 137.937L145.063 119.104L141.654 120.83Z",
    fill: "#1F1F1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.246 140.541L152.907 140.163L172.288 120.37L175.384 123.201L153.246 140.541ZM172.307 121.077L155.973 137.759L174.598 123.171L172.307 121.077Z",
    fill: "#1F1F1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.9 140.51L137.289 123.139L141.375 120.366L153.307 140.209L152.9 140.51ZM138.056 123.233L151.501 138.193L141.216 121.088L138.056 123.233Z",
    fill: "#1F1F1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.784 93.0536L162.054 92.4204L147.558 71.3286L156.435 71.969L170.784 93.0536ZM162.334 91.9306L169.772 92.4703L156.153 72.4588L148.577 71.9122L162.334 91.9306Z",
    fill: "#1F1F1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.76 93.0254L139.147 71.9915L148.195 71.3564L148.277 71.4762L162.655 92.3975L153.76 93.0254ZM140.075 72.436L154.013 92.4979L161.733 91.953L147.94 71.8839L140.075 72.436Z",
    fill: "#1F1F1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.219 140.559L152.932 140.14L175.039 122.825L177.523 126.144L153.219 140.559ZM174.943 123.546L156.343 138.115L176.776 125.996L174.943 123.546Z",
    fill: "#1F1F1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.935 140.542L134.024 126.089L137.693 122.828L153.278 140.17L152.935 140.542ZM134.823 126.059L151.078 138.484L137.652 123.544L134.823 126.059Z",
    fill: "#1F1F1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.522 94.8965L170.124 92.9873L155.72 71.8228L164.25 73.7581L178.522 94.8965ZM170.432 92.5358L177.382 94.1157L163.942 74.2095L156.867 72.6045L170.432 92.5358Z",
    fill: "#1F1F1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.443 94.7929L130.695 73.8136L139.724 71.9302L154.314 92.9316L145.443 94.7929ZM131.555 74.1538L145.666 94.2261L153.458 92.5914L139.498 72.4969L131.555 74.1538Z",
    fill: "#1F1F1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.148 48.7926L152.399 47.879L157.08 23.6729L173.913 24.8708L165.148 48.7926ZM153.007 47.4126L164.802 48.2577L173.203 25.3303L157.494 24.2122L153.007 47.4126Z",
    fill: "#1F1F1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.83 48.7982L140.314 24.8667L157.599 23.666L152.915 47.8861L139.83 48.7982ZM140.813 25.342L140.35 48.2524L152.49 47.4058L156.974 24.2193L140.813 25.342Z",
    fill: "#1F1F1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.721 136.823L179.394 132.636L206.372 125.009L207.045 132.947L179.721 136.823ZM179.933 133.012L180.185 136.243L206.498 132.511L205.917 125.666L179.933 133.012Z",
    fill: "#1F1F1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.815 136.817L101.909 132.938L105.569 125.031L129.706 132.672L127.815 136.817ZM102.656 132.535L127.511 136.257L129.005 132.984L105.842 125.651L102.656 132.535Z",
    fill: "#1F1F1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.19 140.574L152.959 140.122L177.258 125.71L179.063 129.438L153.19 140.574ZM177.041 126.43L156.608 138.55L178.373 129.181L177.041 126.43Z",
    fill: "#1F1F1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.973 140.567L131.224 129.392L134.387 125.726L153.243 140.138L152.973 140.567ZM132.031 129.235L150.67 138.812L134.459 126.421L132.031 129.235Z",
    fill: "#1F1F1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.945 52.0658L215.659 42.0362L234.918 22.5264L248.991 34.9266L226.945 52.0658ZM216.397 42.0119L226.967 51.4047L248.194 34.9022L234.943 23.2257L216.397 42.0119Z",
    fill: "#1F1F1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.8201 52.0758L61.3433 34.872L80.1307 22.5215L91.8934 42.1054L76.8201 52.0758ZM62.1171 34.9719L76.9051 51.4098L91.2065 41.9499L79.9673 23.2377L62.1171 34.9719Z",
    fill: "#1F1F1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.749 51.4356L164.637 48.7096L173.396 24.8037L189.394 28.3857L176.749 51.4356ZM165.314 48.3406L176.487 50.8555L188.623 28.7344L173.72 25.3972L165.314 48.3406Z",
    fill: "#1F1F1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.222 51.4522L123.487 28.3604L140.825 24.791L140.34 48.7332L127.222 51.4522ZM124.067 28.7602L127.64 50.8463L139.84 48.3175L140.303 25.4178L124.067 28.7602Z",
    fill: "#1F1F1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.698 97.9193L177.785 94.7131L163.42 73.4375L171.454 76.6763L171.497 76.7414L185.698 97.9193ZM178.119 94.2998L184.352 96.8252L171.118 77.0896L164.772 74.5307L178.119 94.2998Z",
    fill: "#1F1F1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.301 97.6755L122.41 76.758L131.223 73.6807L145.956 94.6386L137.301 97.6755ZM123.217 77.0148L137.493 97.069L145.153 94.3813L131.027 74.2876L123.217 77.0148Z",
    fill: "#1F1F1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.158 140.585L152.988 140.107L178.887 128.96L179.974 133L153.158 140.585ZM178.549 129.659L156.756 139.039L179.353 132.648L178.549 129.659Z",
    fill: "#1F1F1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.012 140.583L128.961 132.97L131.539 128.982L153.205 140.114L153.012 140.583ZM129.75 132.686L150.288 139.187L131.716 129.645L129.75 132.686Z",
    fill: "#1F1F1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.195 102.125L184.814 97.5134L170.419 76.0464L177.904 80.7101L192.195 102.125ZM185.206 97.1848L190.468 100.454L177.511 81.0382L172.153 77.7187L185.206 97.1848Z",
    fill: "#1F1F1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.53 101.618L114.492 80.7614L122.894 76.5615L137.776 97.4661L129.53 101.618ZM115.254 80.9492L129.689 100.969L137.018 97.2783L122.732 77.2112L115.254 80.9492Z",
    fill: "#1F1F1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.125 140.592L153.02 140.096L179.893 132.495L180.225 136.751L153.125 140.592ZM179.434 133.153L156.782 139.56L179.681 136.315L179.434 133.153Z",
    fill: "#1F1F1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.051 140.592L127.292 136.738L129.218 132.518L153.166 140.098L153.051 140.592ZM128.035 136.335L149.951 139.614L129.494 133.138L128.035 136.335Z",
    fill: "#1F1F1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.449 55.7602L176.257 51.275L188.894 28.2407L203.678 34.127L187.449 55.7602ZM176.979 51.0162L187.277 55.1428L202.872 34.3536L189.123 28.8795L176.979 51.0162Z",
    fill: "#1F1F1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.87 55.7777L106.984 34.0882L123.98 28.2212L127.716 51.3193L114.87 55.7777ZM107.639 34.4001L115.177 55.133L127.146 50.979L123.575 28.8991L107.639 34.4001Z",
    fill: "#1F1F1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.303 140.595L179.719 136.309L207.054 132.432L206.311 140.591L179.303 140.595ZM180.187 136.756L179.863 140.086L205.846 140.082L206.489 133.026L180.187 136.756Z",
    fill: "#1F1F1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.7616 140.598L102.1 132.452L127.986 136.328L126.787 140.595L99.7616 140.598ZM102.466 133.021L100.437 140.09L126.401 140.086L127.34 136.745L102.466 133.021Z",
    fill: "#1F1F1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.814 140.595H153.089L153.053 140.089L180.237 136.235L179.814 140.595ZM156.695 140.086H179.352L179.669 136.83L156.695 140.086Z",
    fill: "#1F1F1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.089 140.595H126.258L127.479 136.252L153.127 140.089L153.089 140.595ZM126.93 140.086H149.671L127.847 136.821L126.93 140.086Z",
    fill: "#1F1F1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.06 107.728L191.12 101.431L176.344 79.29L183.367 85.6507L198.06 107.728ZM191.526 101.122L195.371 104.606L182.962 85.9589L179.04 82.4127L191.526 101.122Z",
    fill: "#1F1F1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.318 106.519L107.136 85.7313L114.936 80.5073L129.97 101.357L122.318 106.519ZM107.859 85.859L122.44 105.823L129.25 101.229L114.811 81.2032L107.859 85.859Z",
    fill: "#1F1F1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.747 144.437L153.051 140.592L153.089 140.086H179.914L178.747 144.437ZM156.507 140.595L178.374 143.867L179.251 140.595H156.507Z",
    fill: "#1F1F1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.888 144.453L126.366 140.086H153.089L153.125 140.593L125.888 144.453ZM126.822 140.595L126.464 143.858L149.483 140.595H126.822Z",
    fill: "#1F1F1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.989 61.6706L186.992 55.522L203.21 33.9028L216.435 41.9743L196.989 61.6706ZM187.734 55.381L196.911 61.0254L215.622 42.0741L203.34 34.5778L187.734 55.381Z",
    fill: "#1F1F1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.06 61.6843L91.1899 41.9221L107.454 33.8906L115.34 55.5821L103.06 61.6843ZM91.9101 42.1337L103.255 61.0197L114.706 55.3288L107.17 34.5979L91.9101 42.1337Z",
    fill: "#1F1F1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.266 148.256L178.241 144.361L179.388 140.086L206.408 140.083L204.266 148.256ZM178.88 143.942L203.89 147.685L205.749 140.591L179.778 140.595L178.88 143.942Z",
    fill: "#1F1F1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.9242 148.276L99.8726 140.09L126.878 140.086L126.407 144.38L98.9242 148.276ZM100.326 140.599L99.5053 147.68L125.945 143.932L126.31 140.595L100.326 140.599Z",
    fill: "#1F1F1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.048 148.19L153.012 140.583L153.127 140.089L178.928 143.95L177.048 148.19ZM156.228 141.067L176.767 147.568L178.193 144.354L156.228 141.067Z",
    fill: "#1F1F1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.188 148.213L125.907 143.937L153.053 140.089L153.158 140.585L126.188 148.213ZM126.445 144.374L126.654 147.552L149.394 141.121L126.445 144.374Z",
    fill: "#1F1F1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.735 63.4983L226.6 51.6904L248.637 34.5581L260.061 49.1685L235.735 63.4983ZM227.313 51.7803L235.863 62.8328L259.303 49.025L248.548 35.2708L227.313 51.7803Z",
    fill: "#1F1F1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.6109 63.5004L44.7531 49.1157L61.7533 34.5674L77.2255 51.7659L63.6109 63.5004ZM45.5619 49.0928L63.5915 62.8457L76.4998 51.7198L61.7071 35.2766L45.5619 49.0928Z",
    fill: "#1F1F1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.844 112.049L196.504 106.308L182.944 85.9325L183.359 85.6382L187.749 91.4393L201.259 111.754L200.844 112.049Z",
    fill: "#1F1F1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.842 112.273L100.52 91.563L107.539 85.4209L122.721 106.208L115.842 112.273ZM101.207 91.637L115.922 111.525L122.037 106.134L107.456 86.1694L101.207 91.637Z",
    fill: "#1F1F1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.752 151.759L152.973 140.567L153.166 140.098L177.299 147.736L174.752 151.759ZM155.889 141.493L174.571 151.093L176.516 148.022L155.889 141.493Z",
    fill: "#1F1F1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.152 151.781L126.113 147.705L153.02 140.096L153.189 140.574L127.152 151.781ZM126.729 148.059L127.498 151.078L149.423 141.641L126.729 148.059Z",
    fill: "#1F1F1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.917 155.055L152.935 140.543L153.205 140.114L175.062 151.346L171.917 155.055ZM155.507 141.869L171.842 154.357L174.26 151.506L155.507 141.869Z",
    fill: "#1F1F1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.755 155.068L126.983 151.3L152.988 140.107L153.219 140.559L128.755 155.068ZM127.667 151.559L128.977 154.345L149.569 142.132L127.667 151.559Z",
    fill: "#1F1F1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.95 155.754L176.56 148.035L178.406 143.872L204.444 147.768L200.95 155.754ZM177.255 147.722L200.668 155.131L203.712 148.173L178.714 144.432L177.255 147.722Z",
    fill: "#1F1F1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.4228 155.781L98.947 147.759L126.412 143.865L126.688 148.071L99.4228 155.781ZM99.4824 148.196L99.8932 155.119L126.154 147.694L125.94 144.446L99.4824 148.196Z",
    fill: "#1F1F1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.136 69.0269L196.581 61.3593L216.017 41.6738L227.354 51.7484L205.136 69.0269ZM197.318 61.3369L205.159 68.3649L226.559 51.7225L216.04 42.3747L197.318 61.3369Z",
    fill: "#1F1F1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.61 157.994L152.9 140.51L153.243 140.139L172.277 154.69L168.61 157.994ZM155.1 142.198L168.648 157.275L171.482 154.722L155.1 142.198Z",
    fill: "#1F1F1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.959 157.996L128.496 154.63L152.959 140.122L153.246 140.541L130.959 157.996ZM129.237 154.782L131.059 157.272L149.836 142.565L129.237 154.782Z",
    fill: "#1F1F1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.0757 69.0327L76.4762 51.6933L91.6312 41.6689L103.5 61.4289L92.0757 69.0327ZM77.2491 51.7922L92.1597 68.3657L102.815 61.2744L91.4688 42.3862L77.2491 51.7922Z",
    fill: "#1F1F1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.005 118.478L190.541 98.2604L187.318 91.7047L187.758 91.4517L201.275 111.783L204.445 118.225L204.005 118.478ZM189.495 94.9818L190.981 98.007L202.269 114.954L200.826 112.022L189.495 94.9818Z",
    fill: "#1F1F1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.262 118.746L94.8085 98.1107L100.881 91.1953L116.208 111.912L110.262 118.746ZM95.4631 98.1361L110.292 117.937L115.556 111.886L100.847 92.0049L95.4631 98.1361Z",
    fill: "#1F1F1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.915 160.5L152.871 140.472L153.278 140.171L169.012 157.68L164.915 160.5ZM154.678 142.489L165.072 159.775L168.246 157.589L154.678 142.489Z",
    fill: "#1F1F1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.709 160.492L130.618 157.618L152.932 140.141L153.271 140.519L133.709 160.492ZM131.4 157.651L133.693 159.783L150.203 142.924L131.4 157.651Z",
    fill: "#1F1F1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.914 162.51L152.85 140.428L153.307 140.209L165.352 160.24L160.914 162.51ZM154.237 142.743L161.195 161.795L164.635 160.035L154.237 142.743Z",
    fill: "#1F1F1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.938 162.498L133.3 160.183L152.907 140.163L153.293 140.492L136.938 162.498ZM134.102 160.091L136.812 161.815L150.655 143.189L134.102 160.091Z",
    fill: "#1F1F1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.437 162.903L174.297 151.525L176.798 147.577L201.199 155.299L196.437 162.903ZM175.025 151.327L196.254 162.237L200.419 155.586L177.018 148.18L175.025 151.327Z",
    fill: "#1F1F1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.251 162.926L99.3518 155.272L126.603 147.567L127.625 151.578L101.251 162.926ZM99.9642 155.628L101.601 162.222L127.025 151.282L126.239 148.198L99.9642 155.628Z",
    fill: "#1F1F1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.467 72.4811L147.764 71.8531L152.496 47.376L165.33 48.2956L156.467 72.4811ZM148.372 71.3872L156.121 71.9462L164.621 48.7545L152.91 47.9154L148.372 71.3872Z",
    fill: "#1F1F1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.351 72.4869L139.84 48.2877L153.015 47.3691L148.28 71.8601L139.351 72.4869ZM140.34 48.7625L139.87 71.9406L147.855 71.3803L152.39 47.9224L140.34 48.7625Z",
    fill: "#1F1F1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.715 163.976L152.838 140.382L153.328 140.253L161.381 162.306L156.715 163.976ZM153.779 142.972L157.118 163.291L160.728 162L153.779 142.972Z",
    fill: "#1F1F1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.568 163.956L136.476 162.267L152.885 140.189L153.312 140.462L140.568 163.956ZM137.274 162.046L140.339 163.311L151.162 143.36L137.274 162.046Z",
    fill: "#1F1F1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.424 164.85L152.835 140.336L153.34 140.299L157.207 163.831L152.424 164.85ZM153.296 143.168L152.943 164.219L156.627 163.435L153.296 143.168Z",
    fill: "#1F1F1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.51 164.833L140.071 163.806L152.865 140.219L153.328 140.427L144.51 164.833ZM140.837 163.461L144.185 164.236L151.702 143.43L140.837 163.461Z",
    fill: "#1F1F1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.227 74.2741L155.956 72.3977L164.813 48.228L177.004 50.9717L164.227 74.2741ZM156.632 72.0297L163.965 73.6935L176.233 51.3194L165.137 48.8221L156.632 72.0297Z",
    fill: "#1F1F1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.916 74.2871L127.141 50.9493L140.351 48.2114L139.861 72.4213L130.916 74.2871ZM127.721 51.3487L131.334 73.6807L139.361 72.0061L139.829 48.8387L127.721 51.3487Z",
    fill: "#1F1F1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.147 165.116L152.839 140.293L153.343 140.345L152.934 164.772L148.147 165.116ZM152.785 143.319L148.769 164.562L152.433 164.298L152.785 143.319Z",
    fill: "#1F1F1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.666 165.109L143.994 164.764L152.85 140.254L153.339 140.388L148.666 165.109ZM144.7 164.306L148.25 164.568L152.25 143.412L144.7 164.306Z",
    fill: "#1F1F1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.203 76.3854L235.465 63.0673L259.785 48.7407L268.26 65.2415L242.203 76.3854ZM236.134 63.2635L242.442 75.7302L267.558 64.9887L259.579 49.4524L236.134 63.2635Z",
    fill: "#1F1F1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.1493 76.385L30.3257 65.2017L45.1253 48.7598L63.974 63.1375L52.1493 76.385ZM31.1459 65.0507L52.0316 75.7533L63.2285 63.2085L45.1897 49.4487L31.1459 65.0507Z",
    fill: "#1F1F1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.807 126.786L192.442 105.278L190.094 96.6719L204.462 118.27L206.807 126.786ZM192.922 105.104L205.482 123.889L203.982 118.445L191.411 99.5675L192.922 105.104Z",
    fill: "#1F1F1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.721 125.783L90.1455 105.225L95.1227 97.6816L110.588 118.332L105.721 125.783ZM90.7683 105.204L105.69 124.9L109.967 118.351L95.149 98.5652L90.7683 105.204Z",
    fill: "#1F1F1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.372 77.1916L163.735 74.1127L176.503 50.8257L187.765 55.3387L171.372 77.1916ZM164.457 73.8549L171.2 76.5737L186.961 55.5642L176.733 51.4654L164.457 73.8549Z",
    fill: "#1F1F1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.835 169.517L171.513 154.746L174.598 151.108L196.745 162.49L190.835 169.517ZM172.247 154.667L190.758 168.818L195.945 162.651L174.725 151.745L172.247 154.667Z",
    fill: "#1F1F1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.66 77.2091L114.696 55.2995L127.634 50.8096L131.41 74.1537L122.66 77.2091ZM115.35 55.6109L122.966 76.5634L130.84 73.8141L127.228 51.4885L115.35 55.6109Z",
    fill: "#1F1F1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.368 169.533L101.085 162.444L127.45 151.099L129.195 154.807L104.368 169.533ZM101.766 162.705L104.593 168.808L128.538 154.605L127.199 151.761L101.766 162.705Z",
    fill: "#1F1F1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.69 77.6669L204.792 68.6498L227.002 51.3779L236.177 63.238L211.69 77.6669ZM205.503 68.7416L211.82 76.9998L235.422 63.093L226.911 52.0927L205.503 68.7416Z",
    fill: "#1F1F1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.1798 77.6647L63.1976 63.1852L76.8852 51.3877L92.4798 68.7216L82.1798 77.6647ZM64.0048 63.1609L82.1589 77.0091L91.7557 68.6769L76.8401 52.0979L64.0048 63.1609Z",
    fill: "#1F1F1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.73 81.1747L170.916 76.9528L187.299 55.1138L197.355 61.2993L177.73 81.1747ZM171.656 76.8132L177.653 80.5286L196.544 61.3972L187.427 55.7897L171.656 76.8132Z",
    fill: "#1F1F1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.776 81.1881L102.798 61.2469L115.165 55.1011L123.13 77.0126L114.776 81.1881ZM103.517 61.457L114.97 80.5226L122.497 76.7603L114.881 55.8099L103.517 61.457Z",
    fill: "#1F1F1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.281 175.424L168.27 157.616L171.866 154.376L191.194 169.151L184.281 175.424ZM168.988 157.653L184.318 174.704L190.4 169.184L171.893 155.037L168.988 157.653Z",
    fill: "#1F1F1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.698 175.434L104.111 169.094L128.935 154.37L131.36 157.683L108.698 175.434ZM104.849 169.247L108.801 174.708L130.659 157.586L128.798 155.043L104.849 169.247Z",
    fill: "#1F1F1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.107 133.684L193.055 112.788L192.354 104.254L206.392 125.25L207.107 133.684ZM193.552 112.614L206.435 131.773L205.897 125.424L193.022 106.168L193.552 112.614Z",
    fill: "#1F1F1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.337 133.225L86.6504 112.737L90.4052 104.725L106.001 125.309L102.337 133.225ZM87.2419 112.673L102.229 132.248L105.411 125.373L90.5086 105.704L87.2419 112.673Z",
    fill: "#1F1F1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.928 180.481L164.653 160.064L168.669 157.298L184.682 175.108L176.928 180.481ZM165.335 160.211L177.085 179.753L183.917 175.019L168.589 157.97L165.335 160.211Z",
    fill: "#1F1F1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.14 180.477L108.359 175.053L131.023 157.3L134.065 160.129L114.14 180.477ZM109.14 175.088L114.125 179.765L133.337 160.146L130.995 157.968L109.14 175.088Z",
    fill: "#1F1F1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.143 86.1236L177.324 80.862L196.939 60.9971L205.545 68.7099L183.143 86.1236ZM178.06 80.8412L183.168 85.46L204.751 68.6821L196.96 61.6993L178.06 80.8412Z",
    fill: "#1F1F1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.456 86.1288L91.7318 68.6504L103.239 60.9922L115.216 80.9314L107.456 86.1288ZM92.5037 68.7477L107.539 85.4608L114.53 80.7784L103.077 61.7109L92.5037 68.7477Z",
    fill: "#1F1F1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.487 87.3877L211.422 77.235L235.904 62.8091L242.672 76.1853L216.487 87.3877ZM212.089 77.4321L216.728 86.7316L241.973 75.931L235.695 63.5223L212.089 77.4321Z",
    fill: "#1F1F1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.6166 87.3832L51.6815 76.1454L63.5682 62.8281L82.5411 77.3007L73.6166 87.3832ZM52.4993 75.9929L73.4974 86.7504L81.7976 77.3732L63.6342 63.518L52.4993 75.9929Z",
    fill: "#1F1F1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.962 184.551L160.738 162.029L165.089 159.803L177.364 180.219L168.962 184.551ZM161.37 162.277L169.242 183.834L176.649 180.015L164.898 160.472L161.37 162.277Z",
    fill: "#1F1F1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.558 184.534L113.732 180.166L133.663 159.812L137.243 162.089L120.558 184.534ZM114.533 180.075L120.433 183.85L136.508 162.224L133.738 160.463L114.533 180.075Z",
    fill: "#1F1F1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.183 90.4332L242.016 75.9126L268.073 64.769L273.36 82.7893L246.183 90.4332ZM242.629 76.2037L246.532 89.8064L272.727 82.4392L267.746 65.4619L242.629 76.2037Z",
    fill: "#1F1F1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.7264 90.4265L18.429 82.7651L30.6518 64.7974L52.4614 75.9736L42.7264 90.4265ZM19.2341 82.4855L42.5168 89.827L51.7194 76.1647L30.8197 65.455L19.2341 82.4855Z",
    fill: "#1F1F1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.589 187.521L156.631 163.465L161.206 161.828L169.428 184.345L160.589 187.521ZM157.202 163.801L160.992 186.836L168.775 184.039L160.902 162.477L157.202 163.801Z",
    fill: "#1F1F1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.794 187.505L120.097 184.302L136.789 161.846L140.812 163.506L127.794 187.505ZM120.894 184.083L127.566 186.86L140.096 163.76L136.961 162.467L120.894 184.083Z",
    fill: "#1F1F1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.267 141.069L192.313 120.475L193.117 111.969L207.033 132.662L206.267 141.069ZM192.836 120.341L205.89 139.605L206.51 132.796L193.49 113.434L192.836 120.341Z",
    fill: "#1F1F1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.205 140.897L84.4148 120.465L86.8428 112.152L102.563 132.683L100.205 140.897ZM84.9756 120.359L99.9932 139.791L102.003 132.789L87.0494 113.258L84.9756 120.359Z",
    fill: "#1F1F1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.014 189.32L152.433 164.328L157.124 163.329L161.081 187.377L152.014 189.32ZM152.935 164.741L152.533 188.688L160.5 186.981L156.709 163.938L152.935 164.741Z",
    fill: "#1F1F1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.668 189.303L127.297 187.355L140.323 163.342L144.684 164.352L135.668 189.303ZM128.063 187.01L135.343 188.705L144.011 164.718L140.585 163.924L128.063 187.01Z",
    fill: "#1F1F1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.48 91.9269L182.802 85.7451L205.194 68.3379L212.131 77.4071L187.48 91.9269ZM183.51 85.8384L187.612 91.2589L211.379 77.2601L205.102 69.0541L183.51 85.8384Z",
    fill: "#1F1F1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.875 91.9281L81.7668 77.3495L92.1396 68.3433L107.859 85.8165L100.875 91.9281ZM82.572 77.3241L100.853 91.2715L107.136 85.7733L92.0959 69.055L82.572 77.3241Z",
    fill: "#1F1F1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.462 189.897L148.244 164.599L152.943 164.261L152.524 189.241L143.462 189.897ZM148.672 165.079L144.085 189.342L152.023 188.767L152.425 164.809L148.672 165.079Z",
    fill: "#1F1F1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.981 189.89L135.153 189.232L144.174 164.267L148.761 164.606L143.981 189.89ZM135.859 188.775L143.566 189.349L148.155 165.071L144.521 164.803L135.859 188.775Z",
    fill: "#1F1F1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.183 148.574L190.235 128.192L192.472 119.804L206.354 140.29L204.183 148.574ZM190.787 128.097L203.973 147.367L205.803 140.384L192.676 121.012L190.787 128.097Z",
    fill: "#1F1F1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.3958 148.624L83.5015 128.222L84.5167 119.765L100.364 140.27L99.3958 148.624ZM84.0314 128.074L99.0337 147.331L99.8346 140.417L84.8738 121.058L84.0314 128.074Z",
    fill: "#1F1F1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.392 97.9641L216.302 86.9136L242.487 75.7109L246.672 90.2952L219.392 97.9641ZM216.912 87.2059L219.745 97.3368L246.042 89.9441L242.157 76.4053L216.912 87.2059Z",
    fill: "#1F1F1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.6022 97.9577L42.2206 90.2667L52.0057 75.7397L73.9269 86.9703L66.6022 97.9577ZM43.0227 89.9866L66.3911 97.3577L73.1873 87.163L52.1753 76.3983L43.0227 89.9866Z",
    fill: "#1F1F1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.631 98.4483L187.214 91.4931L211.861 76.9761L216.955 87.1872L190.631 98.4483ZM187.879 91.6923L190.875 97.7907L216.259 86.9319L211.649 77.6908L187.879 91.6923Z",
    fill: "#1F1F1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.1962 98.4399L73.1493 87.1437L82.1356 76.9912L101.234 91.5629L95.1962 98.4399ZM73.9646 86.9898L95.0755 97.8066L100.493 91.6369L82.2032 77.6826L73.9646 86.9898Z",
    fill: "#1F1F1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.859 155.962L186.871 135.743L190.463 127.624L204.367 147.943L200.859 155.962ZM187.452 135.688L200.759 154.923L203.788 147.998L190.559 128.665L187.452 135.688Z",
    fill: "#1F1F1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.96 156.247L83.9415 135.813L83.4669 127.35L99.4638 147.884L99.96 156.247ZM84.4401 135.625L99.356 154.653L98.9656 148.071L84.0659 128.946L84.4401 135.625Z",
    fill: "#1F1F1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.544 105.309L246.084 89.9322L273.266 82.2871L275.212 101.408L247.544 105.309ZM246.63 90.3067L248 104.731L274.657 100.973L272.821 82.9408L246.63 90.3067Z",
    fill: "#1F1F1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.591 105.31L9.38062 101.402L18.6992 82.3169L42.9781 89.9727L35.591 105.31ZM10.1423 101.001L35.2955 104.752L42.2651 90.2811L18.964 82.9338L10.1423 101.001Z",
    fill: "#1F1F1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.51 105.525L190.449 97.973L216.774 86.7119L219.881 97.8267L192.51 105.525ZM191.056 98.2666L192.866 104.897L219.255 97.4746L216.44 87.4078L191.056 98.2666Z",
    fill: "#1F1F1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.5635 105.514L66.0973 97.7985L73.4711 86.7368L95.5044 98.0262L90.5635 105.514ZM66.8959 97.5171L90.3504 104.914L94.7673 98.22L73.643 87.3964L66.8959 97.5171Z",
    fill: "#1F1F1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.332 109.147L219.296 97.4628L246.581 89.7925L248.048 105.238L220.332 109.147ZM219.84 97.8383L220.791 108.568L247.496 104.802L246.133 90.4471L219.84 97.8383Z",
    fill: "#1F1F1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.32 109.143L35.0643 105.232L42.4881 89.8179L66.8517 97.5029L61.32 109.143ZM35.822 104.83L61.0225 108.585L66.1415 97.8124L42.7551 90.4353L35.822 104.83Z",
    fill: "#1F1F1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.357 163.031L182.29 142.942L187.152 135.255L201.113 155.436L196.357 163.031ZM182.901 142.928L196.333 162.11L200.504 155.45L187.171 136.176L182.901 142.928Z",
    fill: "#1F1F1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.957 163.66L85.7174 142.999L83.6621 134.632L99.9049 155.389L101.957 163.66ZM86.1982 142.824L100.895 161.488L99.4243 155.564L84.7195 136.806L86.1982 142.824Z",
    fill: "#1F1F1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.072 112.991L192.417 105.023L219.795 97.3228L220.836 109.075L193.072 112.991ZM192.959 105.399L193.535 112.412L220.287 108.639L219.342 97.9784L192.959 105.399Z",
    fill: "#1F1F1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.0962 112.984L60.7943 109.065L66.362 97.3486L90.8105 105.059L87.0962 112.984ZM61.5483 108.663L86.7962 112.426L90.1033 105.369L66.6312 97.967L61.5483 108.663Z",
    fill: "#1F1F1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.78 169.583L176.604 149.606L182.615 142.52L196.666 162.585L190.78 169.583ZM177.248 149.633L190.814 168.752L196.025 162.556L182.576 143.351L177.248 149.633Z",
    fill: "#1F1F1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.618 171.022L88.8184 149.73L84.8291 141.086L101.657 162.467L105.618 171.022ZM89.2676 149.489L103.343 167.319L101.208 162.708L87.0994 144.791L89.2676 149.489Z",
    fill: "#1F1F1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.715 120.659H246.235L247.535 104.797L275.212 100.895L273.715 120.659ZM246.787 120.15H273.244L274.657 101.487L248.009 105.244L246.787 120.15Z",
    fill: "#1F1F1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.9426 120.67H3.43774L9.58334 100.918L35.7725 104.823L30.9426 120.67ZM4.12862 120.161H30.5659L35.1139 105.239L9.93946 101.485L4.12862 120.161Z",
    fill: "#1F1F1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.745 120.659H219.265L220.326 108.633L248.051 104.724L246.745 120.659ZM219.82 120.15H246.277L247.493 105.316L220.797 109.08L219.82 120.15Z",
    fill: "#1F1F1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.9141 120.67H30.4109L35.2639 104.748L61.4988 108.656L57.9141 120.67ZM31.0975 120.161H57.5351L60.8437 109.073L35.6225 105.315L31.0975 120.161Z",
    fill: "#1F1F1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.26 175.443L169.95 155.56L176.968 149.239L191.135 169.204L184.26 175.443ZM170.629 155.633L184.339 174.684L190.459 169.13L176.884 150L170.629 155.633Z",
    fill: "#1F1F1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.55 175.229L93.1748 155.762L88.8433 149.772L89.249 149.466L104.68 169.013L108.956 174.922L108.55 175.229Z",
    fill: "#1F1F1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.295 120.662L193.069 112.478L220.843 108.561L219.776 120.659L192.295 120.662ZM193.538 112.925L192.854 120.154L219.31 120.15L220.28 109.154L193.538 112.925Z",
    fill: "#1F1F1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.3833 120.67L60.9907 108.58L87.2719 112.496L84.8859 120.666L57.3833 120.67ZM61.3517 109.148L58.0657 120.161L84.5044 120.157L86.6203 112.914L61.3517 109.148Z",
    fill: "#1F1F1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.947 180.467L162.487 160.659L170.35 155.246L184.657 175.125L176.947 180.467ZM163.206 160.781L177.066 179.767L183.942 175.002L170.228 155.947L163.206 160.781Z",
    fill: "#1F1F1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.958 180.306L108.575 175.256L93.1747 155.762L93.5481 155.418L99.0096 160.538L114.332 179.963L113.958 180.306ZM95.6774 158.11L108.949 174.913L111.836 177.62L98.6361 160.881L95.6774 158.11Z",
    fill: "#1F1F1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.026 184.517L154.405 164.757L162.924 160.395L177.387 180.207L169.026 184.517ZM155.17 164.936L169.177 183.867L176.626 180.027L162.769 161.045L155.17 164.936Z",
    fill: "#1F1F1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.622 185.215L113.932 180.278L97.7046 159.7L105.499 164.693L121.622 185.215ZM114.305 179.929L119.368 183.169L105.126 165.041L99.9669 161.748L114.305 179.929Z",
    fill: "#1F1F1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.708 132.303L190.192 128.354L192.379 120.154L219.872 120.15L216.708 132.303ZM190.83 127.935L216.331 131.733L219.214 120.659L192.77 120.663L190.83 127.935Z",
    fill: "#1F1F1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.9628 132.327L57.5005 120.161L84.9818 120.157L83.9957 128.372L55.9628 132.327ZM57.9488 120.67L56.5508 131.73L83.5372 127.923L84.4086 120.666L57.9488 120.67Z",
    fill: "#1F1F1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.765 136.188L216.202 132.228L219.346 120.15H246.838L242.765 136.188ZM216.837 131.808L242.385 135.617L246.184 120.659H219.739L216.837 131.808Z",
    fill: "#1F1F1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.4008 136.212L30.5315 120.161H58.0132L56.4848 132.254L28.4008 136.212ZM30.977 120.67L28.993 135.615L56.0289 131.804L57.4362 120.67H30.977Z",
    fill: "#1F1F1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.7 187.481L145.903 167.753L154.88 164.543L169.509 184.316L160.7 187.481ZM146.723 168L160.881 186.876L168.694 184.068L154.695 165.149L146.723 168Z",
    fill: "#1F1F1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.477 187.79L120.336 184.402L104.499 164.243L112.763 167.668L128.477 187.79ZM120.654 183.983L126.883 186.576L112.444 168.086L106.1 165.457L120.654 183.983Z",
    fill: "#1F1F1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.87 140.08L242.26 136.113L246.313 120.15H273.805L268.87 140.08ZM242.891 135.693L268.488 139.509L273.155 120.659H246.709L242.891 135.693Z",
    fill: "#1F1F1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.787598 140.108L3.56178 120.161H31.0445L28.9235 136.138L0.787598 140.108ZM4.00456 120.67L1.38433 139.51L28.4701 135.689L30.4639 120.67H4.00456Z",
    fill: "#1F1F1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.169 189.286L137.192 169.559L146.419 167.594L146.516 167.724L161.232 187.344L152.169 189.286ZM138.082 169.889L152.378 188.721L160.348 187.013L146.207 168.159L138.082 169.889Z",
    fill: "#1F1F1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.145 189.414L127.535 187.41L111.96 167.466L120.71 169.501L136.145 189.414ZM127.825 186.956L134.866 188.594L120.419 169.955L113.247 168.288L127.825 186.956Z",
    fill: "#1F1F1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.655 189.883L128.492 170.127L137.756 169.46L152.76 189.224L143.655 189.883ZM129.47 170.567L143.892 189.356L151.788 188.784L137.518 169.987L129.47 170.567Z",
    fill: "#1F1F1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.321 189.915L135.374 189.249L120.014 169.432L129.113 170.101L129.183 170.192L144.321 189.915ZM135.637 188.759L143.226 189.324L128.849 170.592L121.116 170.023L135.637 188.759Z",
    fill: "#1F1F1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.695 143.719L186.814 135.872L190.357 127.864L216.885 131.815L211.695 143.719ZM187.509 135.558L211.412 143.096L216.153 132.221L190.665 128.424L187.509 135.558Z",
    fill: "#1F1F1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.5826 143.746L55.9913 131.81L84.0049 127.857L84.4561 135.909L56.5826 143.746ZM56.5223 132.248L57.0589 143.084L83.9256 135.53L83.528 128.439L56.5223 132.248Z",
    fill: "#1F1F1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.177 151.441L211.208 143.565L216.364 131.738L242.939 135.699L236.177 151.441ZM211.9 143.25L235.891 150.818L242.211 136.105L216.674 132.298L211.9 143.25Z",
    fill: "#1F1F1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.1111 151.472L28.4329 135.694L56.497 131.738L57.0848 143.605L29.1111 151.472ZM28.9608 136.133L29.5916 150.808L56.5568 143.225L56.0165 132.319L28.9608 136.133Z",
    fill: "#1F1F1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.844 154.617L182.232 143.035L187.051 135.414L211.944 143.264L204.844 154.617ZM182.959 142.836L204.66 153.952L211.164 143.552L187.272 136.017L182.959 142.836Z",
    fill: "#1F1F1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.2406 154.648L56.5166 143.237L84.375 135.403L86.2626 143.088L59.2406 154.648ZM57.1248 143.594L59.5952 153.943L85.6657 142.79L84.0065 136.035L57.1248 143.594Z",
    fill: "#1F1F1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.75 159.192L235.689 151.287L242.419 135.622L269.041 139.591L260.75 159.192ZM236.378 150.971L260.461 158.568L268.317 139.998L242.731 136.183L236.378 150.971Z",
    fill: "#1F1F1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.53979 159.227L0.823486 139.589L28.9388 135.623L29.614 151.331L1.53979 159.227ZM1.34846 140.029L2.02453 158.563L29.0886 150.95L28.4548 136.205L1.34846 140.029Z",
    fill: "#1F1F1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.307 164.723L176.559 149.659L182.532 142.617L205.152 154.204L196.307 164.723ZM177.293 149.58L196.23 164.024L204.352 154.365L182.659 143.253L177.293 149.58Z",
    fill: "#1F1F1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.8843 164.743L59.079 154.164L86.0916 142.607L89.3766 149.725L63.8843 164.743ZM59.7569 154.427L64.1132 164.018L88.722 149.521L85.8368 143.269L59.7569 154.427Z",
    fill: "#1F1F1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.115 166.03L204.389 154.385L211.442 143.106L236.422 150.985L227.115 166.03ZM205.115 154.185L226.929 165.363L235.646 151.274L211.665 143.709L205.115 154.185Z",
    fill: "#1F1F1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.551 166.06L29.0487 150.961L57.0066 143.099L59.715 154.445L59.5181 154.529L32.551 166.06ZM29.6539 151.319L32.9094 165.354L59.121 154.146L56.6349 143.731L29.6539 151.319Z",
    fill: "#1F1F1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.297 173.771L169.93 155.578L176.913 149.29L196.665 164.357L186.297 173.771ZM170.648 155.616L186.333 173.051L195.871 164.391L176.939 149.95L170.648 155.616Z",
    fill: "#1F1F1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.4081 173.781L63.6302 164.303L89.1196 149.287L93.7242 155.654L70.4081 173.781ZM64.3673 164.459L70.5139 173.055L93.0244 155.554L88.979 149.96L64.3673 164.459Z",
    fill: "#1F1F1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.511 177.504L226.661 165.797L235.921 150.827L260.992 158.735L249.511 177.504ZM227.384 165.596L249.323 176.837L260.219 159.025L236.146 151.431L227.384 165.596Z",
    fill: "#1F1F1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.71858 177.539L1.48108 158.715L29.5388 150.823L33.0261 165.857L5.71858 177.539ZM2.08331 159.074L6.0804 176.831L32.4343 165.557L29.1639 151.457L2.08331 159.074Z",
    fill: "#1F1F1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.786 179.58L195.902 164.414L204.688 153.966L227.421 165.615L215.786 179.58ZM196.635 164.333L215.707 178.88L226.624 165.778L204.816 154.603L196.635 164.333Z",
    fill: "#1F1F1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.659 179.605L32.3926 165.575L59.5466 153.964L64.3249 164.484L38.659 179.605ZM33.0678 165.839L38.8912 178.878L63.6727 164.278L59.2894 154.627L33.0678 165.839Z",
    fill: "#1F1F1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.048 181.525L162.505 160.646L170.329 155.261L186.697 173.455L175.048 181.525ZM163.187 160.794L175.205 180.798L185.933 173.366L170.25 155.933L163.187 160.794Z",
    fill: "#1F1F1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.6574 181.521L70.0709 173.399L93.3898 155.27L99.2001 160.717L78.6574 181.521ZM70.8512 173.437L78.6455 180.809L98.4715 160.731L93.359 155.938L70.8512 173.437Z",
    fill: "#1F1F1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.853 187.772L154.472 164.722L162.942 160.385L175.484 181.263L162.853 187.772ZM155.103 164.971L163.133 187.055L174.769 181.06L162.751 161.055L155.103 164.971Z",
    fill: "#1F1F1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.4297 187.763L78.2504 181.209L98.7993 160.398L105.668 164.783L88.4297 187.763ZM79.0525 181.121L88.3071 187.079L104.931 164.917L98.8723 161.049L79.0525 181.121Z",
    fill: "#1F1F1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.455 191.736L185.957 173.392L196.254 164.043L216.142 179.212L202.455 191.736ZM186.673 173.429L202.49 191.014L215.35 179.248L196.283 164.704L186.673 173.429Z",
    fill: "#1F1F1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.3024 191.746L38.408 179.162L64.0704 164.043L70.81 173.469L47.3024 191.746ZM39.1423 179.32L47.4104 191.018L70.1122 173.367L63.9273 164.718L39.1423 179.32Z",
    fill: "#1F1F1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.015 192.352L146.028 167.709L154.94 164.521L163.319 187.566L150.015 192.352ZM146.598 168.045L150.419 191.666L162.667 187.26L154.635 165.171L146.598 168.045Z",
    fill: "#1F1F1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.4816 192.335L87.9688 187.53L105.215 164.54L112.963 167.751L99.4816 192.335ZM88.7679 187.312L99.2557 191.69L112.244 168.003L105.384 165.16L88.7679 187.312Z",
    fill: "#1F1F1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.4 194.544L215.381 179.271L226.957 165.377L249.815 177.089L235.4 194.544ZM216.111 179.189L235.319 193.843L249.02 177.253L227.087 166.016L216.111 179.189Z",
    fill: "#1F1F1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.2582 194.569L5.56335 177.052L32.8603 165.375L39.0999 179.345L13.2582 194.569ZM6.23561 177.318L13.4935 193.839L38.4503 179.137L32.6001 166.04L6.23561 177.318Z",
    fill: "#1F1F1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.869 195.132L137.387 169.517L146.521 167.572L150.506 192.207L136.869 195.132ZM137.887 169.93L137.39 194.5L149.927 191.811L146.104 168.181L137.887 169.93Z",
    fill: "#1F1F1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.533 195.115L98.9847 192.184L112.473 167.585L120.902 169.545L111.533 195.115ZM99.7526 191.841L111.21 194.517L120.227 169.91L112.734 168.168L99.7526 191.841Z",
    fill: "#1F1F1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.755 196.035L128.768 170.107L137.897 169.45L137.379 195.053L123.755 196.035ZM129.193 170.586L124.38 195.48L136.88 194.579L137.377 169.998L129.193 170.586Z",
    fill: "#1F1F1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.274 196.028L111.017 195.045L120.392 169.46L129.285 170.114L124.274 196.028ZM111.726 194.587L123.861 195.487L128.677 170.579L120.738 169.995L111.726 194.587Z",
    fill: "#1F1F1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.447 202.162L174.786 181.088L186.354 173.074L202.854 191.419L187.447 202.162ZM175.467 181.235L187.602 201.433L202.091 191.331L186.276 173.747L175.467 181.235Z",
    fill: "#1F1F1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.2784 202.165L46.9675 191.363L70.4772 173.083L79.015 181.159L58.2784 202.165ZM47.7453 191.402L58.268 201.452L78.2879 181.172L70.4449 173.753L47.7453 191.402Z",
    fill: "#1F1F1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.749 209.847L202.115 191.357L215.731 178.899L235.755 194.175L218.749 209.847ZM202.83 191.392L218.783 209.125L234.964 194.211L215.761 179.561L202.83 191.392Z",
    fill: "#1F1F1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.0021 209.866L13.01 194.124L38.8478 178.903L47.7043 191.434L24.0021 209.866ZM13.7416 194.284L24.1126 209.136L47.0085 191.331L38.7025 179.579L13.7416 194.284Z",
    fill: "#1F1F1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.142 210.582L162.677 187.29L175.222 180.826L187.882 201.898L171.142 210.582ZM163.308 187.537L171.422 209.863L187.167 201.696L175.031 181.497L163.308 187.537Z",
    fill: "#1F1F1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.319 210.573L57.8728 201.852L78.6154 180.84L88.7356 187.355L71.319 210.573ZM58.6734 201.765L71.1973 209.887L88.0011 187.487L78.6874 181.491L58.6734 201.765Z",
    fill: "#1F1F1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.962 216.756L149.932 191.841L163.145 187.088L171.609 210.375L153.962 216.756ZM150.502 192.177L154.367 216.069L170.956 210.07L162.84 187.739L150.502 192.177Z",
    fill: "#1F1F1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.0964 216.743L70.8591 210.338L88.2837 187.11L99.7278 191.887L86.0964 216.743ZM71.6573 210.122L85.8708 216.096L99.0096 192.138L88.4531 187.732L71.6573 210.122Z",
    fill: "#1F1F1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.355 220.514L136.879 194.61L150.425 191.705L154.454 216.61L136.355 220.514ZM137.379 195.023L136.876 219.882L153.875 216.215L150.009 192.314L137.379 195.023Z",
    fill: "#1F1F1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.231 220.501L85.5999 216.591L99.2385 191.721L111.709 194.634L102.231 220.501ZM86.3672 216.249L101.909 219.902L111.034 194.999L99.4988 192.304L86.3672 216.249Z",
    fill: "#1F1F1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.966 223L187.184 201.725L202.511 191.038L219.147 209.529L199.966 223ZM187.865 201.87L200.12 222.27L218.385 209.443L202.434 191.712L187.865 201.87Z",
    fill: "#1F1F1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.7029 223.003L23.6696 209.48L47.3734 191.047L58.6358 201.803L37.7029 223.003ZM24.4451 209.521L37.694 222.289L57.9106 201.814L47.3394 191.718L24.4451 209.521Z",
    fill: "#1F1F1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.784 221.751L123.855 195.518L137.389 194.542L136.865 220.435L118.784 221.751ZM124.28 195.998L119.409 221.195L136.366 219.961L136.869 195.09L124.28 195.998Z",
    fill: "#1F1F1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.303 221.743L101.715 220.43L111.199 194.548L124.372 195.525L119.303 221.743ZM102.424 219.973L118.89 221.202L123.764 195.99L111.544 195.084L102.424 219.973Z",
    fill: "#1F1F1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.524 233.633L170.967 210.1L187.619 201.461L200.4 222.735L179.524 233.633ZM171.598 210.345L179.803 232.914L199.686 222.534L187.429 202.133L171.598 210.345Z",
    fill: "#1F1F1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.0263 233.624L37.299 222.689L58.2376 201.482L71.625 210.165L54.0263 233.624ZM38.0978 222.603L53.9056 232.938L70.8914 210.295L58.3086 202.135L38.0978 222.603Z",
    fill: "#1F1F1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.957 241.442L153.88 216.245L171.435 209.897L179.989 233.425L157.957 241.442ZM154.449 216.579L158.361 240.753L179.338 233.121L171.13 210.548L154.449 216.579Z",
    fill: "#1F1F1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.5587 241.425L53.5674 233.388L71.1737 209.918L86.3422 216.295L72.5587 241.425ZM54.3646 233.173L72.3337 240.778L85.6249 216.545L71.3426 210.541L54.3646 233.173Z",
    fill: "#1F1F1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.835 246.201L136.365 219.992L154.373 216.107L158.449 241.295L135.835 246.201ZM136.866 220.404L136.356 245.567L157.869 240.9L153.956 216.717L136.866 220.404Z",
    fill: "#1F1F1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.8192 246.187L72.0627 241.272L85.8536 216.128L102.407 220.02L92.8192 246.187ZM72.8296 240.931L92.4969 245.588L101.732 220.383L86.1134 216.712L72.8296 240.931Z",
    fill: "#1F1F1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.753 247.774L118.884 221.234L136.876 219.924L136.345 246.12L113.753 247.774ZM119.309 221.712L114.378 247.218L135.846 245.647L136.356 220.472L119.309 221.712Z",
    fill: "#1F1F1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.272 247.766L92.3035 246.116L101.897 219.934L119.4 221.241L114.272 247.766ZM93.0127 245.659L113.859 247.226L118.792 221.705L102.242 220.47L93.0127 245.659Z",
    fill: "#1F1F1F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_880_1115"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 274.425,
    height: 247.547,
    fill: "white",
    transform: "translate(0.787598 0.226562)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTechFigure4);
export default __webpack_public_path__ + "static/media/tech-figure-4.78e220248df09d08c8adfa3292a44ace.svg";
export { ForwardRef as ReactComponent };